import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ProfileImage from '@fiverr-private/profile_image';
import { Rating } from '@fiverr-private/orca';
import { USER_SMALL_IMAGE_SIZE } from '../../../constants';
import ReviewerSubDetails from '../../shared/ReviewerSubDetails';
import styles from './styles.module.scss';

export const SingleReviewFooter = ({ user, countryCode, value }) => {
    if (!user) {
        return null;
    }

    return (
        <div className={classnames('flex', 'flex-items-center', 'm-t-12', styles.container)}>
            <div className="flex flex-items-center">
                <ProfileImage className="m-r-8" user={user} profileImageSize={USER_SMALL_IMAGE_SIZE} isImageLazy />
                <span className="tbody-6 co-grey-1200 text-semi-bold">{user.username}</span>
            </div>
            <ReviewerSubDetails countryCode={countryCode} className="reviews-package" />
            <Rating
                score={value}
                color={Rating.COLORS.BLACK}
                theme={Rating.THEMES.ONE_STAR}
                showScore={true}
                scoreMinimumFractionDigits={0}
                scoreMaximumFractionDigits={1}
                scoreClassName={classnames('tbody-5', styles.score)}
            />
        </div>
    );
};

SingleReviewFooter.propTypes = {
    user: PropTypes.shape({
        has_profile_photo: PropTypes.bool.isRequired,
        username: PropTypes.string.isRequired,
        profile_photo: PropTypes.string,
    }).isRequired,
    countryCode: PropTypes.string,
    value: PropTypes.number,
};
